const EMBED_HOSTS = [
  'assets.unicorn.studio/embeds/',
  'storage.googleapis.com/unicornstudio-production/embeds/',
]
const WATERMARK_ASSET = 'us_fwb.png'
const TRANSPARENT_PNG =
  'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

const originalFetch = window.fetch.bind(window)

interface SceneLayer {
  data?: { texture?: { src?: string } }
}
interface ScenePayload {
  layers?: SceneLayer[]
  options?: { freePlan?: boolean; includeLogo?: boolean }
}

function scrub(payload: ScenePayload): ScenePayload {
  if (payload.options) {
    payload.options.freePlan = false
    payload.options.includeLogo = false
  }
  if (Array.isArray(payload.layers)) {
    payload.layers = payload.layers.filter(
      layer => !layer?.data?.texture?.src?.includes(WATERMARK_ASSET),
    )
  }
  return payload
}

window.fetch = async (input, init) => {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.href
        : input.url

  if (url.includes(WATERMARK_ASSET)) {
    const bytes = Uint8Array.from(atob(TRANSPARENT_PNG), c => c.charCodeAt(0))
    return new Response(bytes, {
      status: 200,
      headers: { 'Content-Type': 'image/png' },
    })
  }

  if (EMBED_HOSTS.some(host => url.includes(host))) {
    const response = await originalFetch(input, init)
    if (!response.ok) return response
    const payload = (await response.json()) as ScenePayload
    return new Response(JSON.stringify(scrub(payload)), {
      status: response.status,
      headers: { 'Content-Type': 'application/json' },
    })
  }

  return originalFetch(input, init)
}
